// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"724":"92c491fb","787":"4efac8bd","816":"e03920da","870":"d532d756"}[chunkId] + ".chunk.js";
};